import { createAction } from "@reduxjs/toolkit"
import { EAccountStatus } from "models/enums/EAccountStatus"

export type PopupContent = {
  txn: {
    hash: string
    success: boolean
    summary?: string
  }
}

export enum ApplicationModal {
  WALLET,
  CLAIM_POPUP
}

export interface SnackbarState {
  open: boolean
  message: string
  severity: "success" | "error"
  autoHideDuration: number
}

export const setOpenModal = createAction<ApplicationModal | null>("application/setOpenModal")
export const setAccountStatus = createAction<EAccountStatus>("application/setAccountStatus")
export const showSnackbar = createAction<{ message: string; severity: "success" | "error"; autoHideDuration?: number }>("application/showSnackbar")
export const hideSnackbar = createAction("application/hideSnackbar")
